import React from 'react';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import cx from 'classnames';
import config from '@plone/volto/registry';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const ShowcaseTeaserBlockTemplate = (props) => {
  const { className, data, isEditMode, style } = props;
  const intl = useIntl();
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const url = data.preview_image?.[0]?.['@id'];

  const Image = config.getComponent('Image').component;

  return (
    <div className={cx('block teaser showcase', className)} style={style}>
      <>
        {!href && isEditMode && (
          <Message>
            <div className="teaser-item placeholder">
              <img src={imageBlockSVG} alt="" />
              <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
            </div>
          </Message>
        )}
        {href && (
          <div>
            <div className="teaser-item default showcase">
              {url && !image?.image_field ? (
                <div className="image-wrapper">
                  <Image src={url} alt="" loading="lazy" responsive={true} />
                </div>
              ) : (
                (href.hasPreviewImage || href.image_field || image) && (
                  <div className="image-wrapper">
                    <Image
                      item={image || href}
                      imageField={image ? image.image_field : href.image_field}
                      alt=""
                      loading="lazy"
                      responsive={true}
                    />
                  </div>
                )
              )}
              <div className="content">
                <div className="teaser-title">
                  {data?.head_title && (
                    <div className="headline">{data.head_title}</div>
                  )}
                  <h2>{data?.title}</h2>
                </div>
                <div className="teaser-text">
                  {!data.hide_description && <p>{data?.description}</p>}
                </div>
                <div className="teaser-cta">
                  {data?.cta_label && (
                    <ConditionalLink
                      to={flattenToAppURL(href['@id'])}
                      condition={!isEditMode}
                    >
                      <div className="cta" role="button" tabIndex={0}>
                        {data?.cta_label}
                      </div>
                    </ConditionalLink>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default ShowcaseTeaserBlockTemplate;
